import { render, staticRenderFns } from "./deliverymodel.vue?vue&type=template&id=26179229&scoped=true&"
import script from "./deliverymodel.vue?vue&type=script&lang=js&"
export * from "./deliverymodel.vue?vue&type=script&lang=js&"
import style0 from "./deliverymodel.vue?vue&type=style&index=0&id=26179229&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26179229",
  null
  
)

export default component.exports